export var ModalStatusEnum;
(function (ModalStatusEnum) {
    ModalStatusEnum["CLOSED"] = "closed";
    ModalStatusEnum["CLOSING"] = "closing";
    ModalStatusEnum["OPENED"] = "opened";
    ModalStatusEnum["OPENING"] = "opening";
})(ModalStatusEnum || (ModalStatusEnum = {}));
//# sourceMappingURL=modal-status.js.map
